export function fromCurrencyStringToCents(strValue) {
  const value = parseFloat(strValue);
  return isNaN(value) ? undefined : Math.round(100 * value);
}

export function fromCentsToCurrencyString(value) {
  return value ? `${value / 100}` : '';
}
